/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    MoyaContainer.register('road.dropdown-toggle', function () {
        return {
            create: RoadDropdown.create,
        };
    });
    var RoadDropdown = /** @class */ (function () {
        function RoadDropdown(el) {
            this.el = el;
        }
        RoadDropdown.create = function (el) {
            return new RoadDropdown(el).run();
        };
        RoadDropdown.prototype.run = function () {
            var el = this.el;
            var dialog = document.querySelector(el.dataset.dialog);
            if (dialog === null) {
                return;
            }
            var toggleKey = el.dataset.toggleKey;
            var isTraffic = el.dataset.dialog.includes('traffic');
            var toggle = MoyaContainer.get('core.toggle').create(el, dialog, toggleKey, {
                closeOthers: !isTraffic,
                onOpen: function () {
                    [].slice.call(dialog.parentElement.children).forEach(function (sibling) {
                        sibling.classList.remove('open');
                    });
                    dialog.classList.add('open');
                },
                onClose: function () {
                    dialog.classList.remove('open');
                },
            });
            var closeButton = document.querySelector('button.road-close.dropdown-close');
            if (closeButton) {
                closeButton.addEventListener('click', function () {
                    toggle.close();
                });
            }
            if (isTraffic) {
                var tableRow = el.parentElement.parentElement;
                tableRow.addEventListener('click', function () {
                    toggle.isOpen() ? toggle.close() : toggle.open();
                });
            }
            MoyaContainer.set('road.dropdown-toggle', toggle);
        };
        return RoadDropdown;
    }());

    exports.RoadDropdown = RoadDropdown;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
